// TODO: Move to /shared/directives
import {
  Attribute,
  Directive,
  ElementRef,
  HostListener,
  Renderer2,
} from '@angular/core';
@Directive({
  selector: '[fzSrcError]',
})
export class SrcErrorDirective {
  constructor(
    @Attribute('fzSrcError') public fzSrcError: string,
    private renderer: Renderer2,
    private el: ElementRef,
  ) {}
  @HostListener('error') onError() {
    const url = this.fzSrcError || '';
    this.renderer.setAttribute(this.el.nativeElement, 'src', url);
  }
}
